export class LocalStorageProvider {
    constructor(BRANCH_PERSIST = 'BRANCH_PERSIST', localStorage = window.localStorage) {
        this.BRANCH_PERSIST = BRANCH_PERSIST;
        this.localStorage = localStorage;
    }
    getLocalStorage() {
        const item = this.localStorage.getItem(this.BRANCH_PERSIST);
        if (!item) {
            return {};
        }
        try {
            return JSON.parse(item) || {};
        }
        catch (err) {
            return {};
        }
    }
    setLocalStorage(store) {
        this.localStorage.setItem(this.BRANCH_PERSIST, JSON.stringify(store));
    }
    get(key) {
        const store = this.getLocalStorage();
        return store[key];
    }
    set(key, value) {
        const store = this.getLocalStorage();
        store[key] = value;
        this.setLocalStorage(store);
    }
}
//# sourceMappingURL=LocalStorageProvider.js.map